import { handleActions } from 'redux-actions';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import IndexedAsyncData from 'conversations-async-data/indexed-async-data/IndexedAsyncData';
import { updateEntry } from 'conversations-async-data/indexed-async-data/operators/updateEntry';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { FETCH_CHATFLOW_CONNECTION_STATUS } from '../constants/asyncActionTypes';
const initialState = new IndexedAsyncData({
  name: 'chatflowConnectionStatus',
  notSetValue: new AsyncData({
    data: null
  })
});
export default handleActions(
// @ts-expect-error IndexedAsyncData is not typed properly with idTransform
{
  [FETCH_CHATFLOW_CONNECTION_STATUS.STARTED]: (state, action) => {
    const {
      chatflowId
    } = action.payload.requestArgs;
    // @ts-expect-error IndexedAsyncData is not typed properly with idTransform
    return updateEntry(chatflowId, requestStarted, state);
  },
  [FETCH_CHATFLOW_CONNECTION_STATUS.SUCCEEDED](state, action) {
    const {
      data,
      requestArgs
    } = action.payload;
    const {
      chatflowId
    } = requestArgs;
    return updateEntry(chatflowId, requestSucceededWithOperator(() => data),
    // @ts-expect-error IndexedAsyncData is not typed properly with idTransform
    state);
  },
  [FETCH_CHATFLOW_CONNECTION_STATUS.FAILED](state, action) {
    const {
      chatflowId
    } = action.payload.requestArgs;
    // @ts-expect-error IndexedAsyncData is not typed properly with idTransform
    return updateEntry(chatflowId, requestFailed, state);
  }
}, initialState);